import { EmptyState } from "taskguard-ui/empty-state";
import { BoardPanel } from "taskguard-ui/surfaces";
import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { TodoBoard } from "../../components/todo-board";

import { useTodoStore } from "../../store";

export function VaultDetailPage() {
  const { vaultId } = useParams();
  const activeVaultId = useTodoStore((state) => state.activeVaultId);
  const setActiveVault = useTodoStore((state) => state.setActiveVault);
  const vault = useTodoStore((state) => (vaultId == null ? null : (state.vaults[vaultId] ?? null)));

  useEffect(() => {
    if (vaultId == null || vault == null || activeVaultId === vaultId) {
      return;
    }

    setActiveVault(vaultId);
  }, [activeVaultId, setActiveVault, vault, vaultId]);

  if (vaultId == null || vault == null) {
    return <Navigate replace to="/vaults" />;
  }

  return (
    <>
      {activeVaultId !== vaultId ? (
        <BoardPanel empty>
          <EmptyState title="Opening vault...">Preparing {vault.name} so this browser can read and sync the correct list.</EmptyState>
        </BoardPanel>
      ) : (
        <TodoBoard />
      )}
    </>
  );
}
